module.exports = __webpack_public_path__ + "static/media/declared_attack_120.97132456.png";